import { Button } from 'react-bootstrap';
import { useApp } from '../../../hook/app.hook';
import { memo } from 'react';
import { Question, Section } from '../../../response/test.response';

const ForwardBackwardComponent = () => {
  const {
    testRes,
    moveNext,
    movePrevious,
    updateActiveSection,
    updateActiveQuestion,
  } = useApp();

  const section = testRes.sectionList.filter(
    (section: Section) => section.active,
  )[0];

  const activeQuestionIndex = section.questionList.filter(
    (question: Question) => question.active,
  )[0].index;

  const currentSectionIndex = testRes.sectionList.findIndex(
    (section: Section) => section.active,
  );

  const handlePrevious = () => {
    // If not the first question in current section, use normal movePrevious
    if (activeQuestionIndex > 1) {
      movePrevious();
    } else {
      // If first question of current section
      if (currentSectionIndex > 0) {
        // Go to previous section's last question
        const previousSection = testRes.sectionList[currentSectionIndex - 1];
        updateActiveSection(previousSection.id);
        // Set the last question as active
        const lastQuestionId =
          previousSection.questionList[previousSection.questionList.length - 1]
            .id;
        updateActiveQuestion(lastQuestionId);
      } else {
        // If first section, go to last section's last question (rotation)
        const lastSection = testRes.sectionList[testRes.sectionList.length - 1];
        updateActiveSection(lastSection.id);
        const lastQuestionId =
          lastSection.questionList[lastSection.questionList.length - 1].id;
        updateActiveQuestion(lastQuestionId);
      }
    }
  };

  const handleNext = () => {
    // If not the last question in current section, use normal moveNext
    if (activeQuestionIndex < section.questionList.length) {
      moveNext();
    } else {
      // If last question of current section
      if (currentSectionIndex < testRes.sectionList.length - 1) {
        // Go to next section's first question
        const nextSection = testRes.sectionList[currentSectionIndex + 1];
        updateActiveSection(nextSection.id);
        // Set the first question as active
        const firstQuestionId = nextSection.questionList[0].id;
        updateActiveQuestion(firstQuestionId);
      } else {
        // If last section, go to first section's first question (rotation)
        const firstSection = testRes.sectionList[0];
        updateActiveSection(firstSection.id);
        const firstQuestionId = firstSection.questionList[0].id;
        updateActiveQuestion(firstQuestionId);
      }
    }
  };

  return (
    <div className="prev--next--wrapper">
      <Button
        onClick={handlePrevious}
        variant="link"
        className="p-2 bg-white rounded-circle d-flex align-items-center justify-content-center position-fixed prev--next-btn prev--btn"
      >
        <img src="/images/prev-icon.svg" height="12" alt="" />
      </Button>
      <Button
        onClick={handleNext}
        variant="link"
        className="p-2 bg-white rounded-circle d-flex align-items-center justify-content-center position-fixed prev--next-btn next--btn"
      >
        <img src="/images/next-icon.svg" height="12" alt="" />
      </Button>
    </div>
  );
};

export default memo(ForwardBackwardComponent);
